import geospatialAPI from '@/api/modules/geospatial.api.js';
import { ErrorService } from '@/services/error-service.js';
import i18n from '@/common/i18n/i18n.js';

/**************** STATE *******************/
const state = {
  currentGeographicLayerStyles: [],
  currentGeographicLayerStyle: null,
  currentGeographicLayerStyleConfig: null,
};

/**************** GETTERS *****************/
const getters = {};

/*************** MUTATIONS ****************/
const mutations = {
  SET_CURRENT_GEOGRAPHIC_LAYER_STYLES: (state, payload) => {
    state.currentGeographicLayerStyles = payload;
  },
  SET_CURRENT_GEOGRAPHIC_LAYER_STYLE: (state, payload) => {
    state.currentGeographicLayerStyle = payload;
  },
  SET_CURRENT_GEOGRAPHIC_LAYER_STYLE_CONFIG: (state, payload) => {
    state.currentGeographicLayerStyleConfig = payload;
  }
};
/**************** ACTIONS *****************/
const actions = {
  GET_CURRENT_GEOGRAPHIC_LAYER_STYLES: async ({ commit }, geographiclayerId) => {
    const styles = await geospatialAPI.getGeographicLayerStylesList(geographiclayerId);
    commit('SET_CURRENT_GEOGRAPHIC_LAYER_STYLES', styles.results);
  },
  SAVE_CURRENT_GEOGRAPHIC_LAYER_STYLE: async ({ dispatch }, { geographiclayerId, styleId = null, data, config, sld }) => {
    const kwargs = {
      kwargs: {
        sld: sld
      }
    };
    if (styleId === null) {
      const geographiclayerStyle = await geospatialAPI.createGeographicLayerStyle(
        geographiclayerId,
        data
      );
      await geospatialAPI.setGeographicLayerStyleConfig(
        geographiclayerId,
        geographiclayerStyle.id,
        config
      );
      const scenarios = await geospatialAPI.getGeographicLayerStyleScenarios(
        geographiclayerId,
        geographiclayerStyle.id
      );
      if (scenarios && scenarios.length) {
        const createScenario = scenarios.find(el => el.action === 'create');
        if (createScenario && createScenario.id) {
          await geospatialAPI.runGeographicLayerStyleScenario(
            geographiclayerId,
            geographiclayerStyle.id,
            createScenario.id,
            kwargs
          );
        }
      } else {
        ErrorService.onError(null, i18n.messages[i18n.locale].messages.error.scenario.none);
      }
      await dispatch('GET_CURRENT_GEOGRAPHIC_LAYER_STYLES', geographiclayerId);
    } else {
      await geospatialAPI.setGeographicLayerStyleConfig(
        geographiclayerId,
        styleId,
        config
      );
      const scenarios = await geospatialAPI.getGeographicLayerStyleScenarios(
        geographiclayerId,
        styleId
      );
      if (scenarios && scenarios.length) {
        const updateScenario = scenarios.find(el => el.action === 'update');
        if (updateScenario && updateScenario.id) {
          await geospatialAPI.runGeographicLayerStyleScenario(
            geographiclayerId,
            styleId,
            updateScenario.id,
            kwargs
          );
        }
      } else {
        ErrorService.onError(null, i18n.messages[i18n.locale].messages.error.scenario.none);
      }
    }
  },
  GET_CURRENT_GEOGRAPHIC_LAYER_STYLE: async ({ commit }, { geographiclayerId, styleId }) => {
    const style = await geospatialAPI.getGeographicLayerStyle(geographiclayerId, styleId);
    commit('SET_CURRENT_GEOGRAPHIC_LAYER_STYLE', style);
    if (style && style.config_href) {
      const config = await geospatialAPI.getGeographicLayerStyleConfig(style.config_href);
      commit('SET_CURRENT_GEOGRAPHIC_LAYER_STYLE_CONFIG', config);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
